import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=4acf1b22&scoped=true&"
import script from "./Transfer.vue?vue&type=script&lang=js&"
export * from "./Transfer.vue?vue&type=script&lang=js&"
import style0 from "./Transfer.vue?vue&type=style&index=0&id=4acf1b22&lang=scss&scoped=true&"
import style1 from "./Transfer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf1b22",
  null
  
)

export default component.exports